<div class="d-lg-block d-none">
  <fgb-banner [title]="'worksheet.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <fgb-worksheet-list></fgb-worksheet-list>
</div>
